import React, { useEffect, useContext } from 'react';

import { useState } from 'react';

import { useHistory } from 'react-router-dom';

import { toast } from "react-toastify";

import Input from '../../shared/components/FormElements/Input';
import Button from '../../shared/components/FormElements/Button';

import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';

import { useForm } from '../../shared/hooks/form-hook';

import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';

import { VALIDATOR_REQUIRE, /*VALIDATOR_EMAIL*/ } from '../../shared/util/validators';

import './RegisterForm.css';

// import footer
//import Footer from '../../shared/components/UIElements/Footer';

const INITIAL_FORM_STATE = {
    name: {
        value: '',
        isValid: false
    },
    gender: {
        value: '',
        isValid: false
    },
    city: {
        value: '',
        isValid: false
    },
    email: {
        value: '',
        isValid: false
    },
    mobile: {
        value: '',
        isValid: false
    },
    highedu: {
        value: '',
        isValid: false
    },
    whatsAppNumber: {
        value: '',
        isValid: true
    },
    preferredLanguage: {
        value: '',
        isValid: true
    },

    interest1: {
        value: '',
        isValid: true
    },
    interest2: {
        value: '',
        isValid: true
    },
    interest3: {
        value: '',
        isValid: true
    },
    interest4: {
        value: '',
        isValid: true
    },

    services1: {
        value: '',
        isValid: true
    },
    services2: {
        value: '',
        isValid: true
    },
    services3: {
        value: '',
        isValid: true
    },
    services4: {
        value: '',
        isValid: true
    },

    cunsultationCharges: {
        value: '',
        isValid: true
    },
    solutionCharges1: {
        value: '',
        isValid: true
    },
    solutionCharges2: {
        value: '',
        isValid: true
    },
    description: {
        value: '',
        isValid: true
    }
};

const UserRegister = () => {

    const auth = useContext(AuthContext);
    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    const [isEditMode, setIsEditMode] = useState(false);

    const [formState, inputHandler, setFormData] = useForm(INITIAL_FORM_STATE, false);

    useEffect(() => {
        const fetchUser = async () => {
            try {


                const responseData = await sendRequest(
                    //`http://localhost:5001/api/users/${auth.userId}/profile`
                    `${process.env.REACT_APP_BACKEND_URL}/users/${auth.userId}/profile`
                );


                if (responseData.userregister) {

                    setIsEditMode(true);

                    /*
                    if (!auth.isRegistered) {
                        auth.setIsRegistered(true);
                    }
                    */
                    //auth.setIsRegistered(true);

                    const user = responseData.userregister;

                    setFormData(
                        {
                            ...INITIAL_FORM_STATE,

                            name: {
                                value: user.name || '',
                                isValid: true
                            },

                            gender: {
                                value: user.gender || '',
                                isValid: true
                            },

                            city: {
                                value: user.city || '',
                                isValid: true
                            },

                            email: {
                                value: user.email || '',
                                isValid: true
                            },

                            mobile: {
                                value: user.mobile || '',
                                isValid: true
                            },

                            highedu: {
                                value: user.highedu || '',
                                isValid: true
                            },

                            whatsAppNumber: {
                                value: user.whatsAppNumber || '',
                                isValid: true
                            },

                            preferredLanguage: {
                                value: user.preferredLanguage || '',
                                isValid: true
                            },

                            interest1: {
                                value: user.interests?.[0] || '',
                                isValid: true
                            },

                            interest2: {
                                value: user.interests?.[1] || '',
                                isValid: true
                            },

                            interest3: {
                                value: user.interests?.[2] || '',
                                isValid: true
                            },

                            interest4: {
                                value: user.interests?.[3] || '',
                                isValid: true
                            },

                            services1: {
                                value: user.services?.[0] || '',
                                isValid: true
                            },

                            services2: {
                                value: user.services?.[1] || '',
                                isValid: true
                            },

                            services3: {
                                value: user.services?.[2] || '',
                                isValid: true
                            },

                            services4: {
                                value: user.services?.[3] || '',
                                isValid: true
                            },

                            cunsultationCharges: {
                                value: user.rateCard?.consultation || '',
                                isValid: true
                            },

                            solutionCharges1: {
                                value: user.rateCard?.solution1 || '',
                                isValid: true
                            },

                            solutionCharges2: {
                                value: user.rateCard?.solution2 || '',
                                isValid: true
                            },

                            description: {
                                value: user.rateCard?.description || '',
                                isValid: true
                            }
                        },
                        true
                    );

                }

            } catch (err) {
                // user profile doesn't exist yet
                try {
                    clearError();

                    const userResponse = await sendRequest(
                        //`http://localhost:5001/api/users/${auth.userId}`,
                        `${process.env.REACT_APP_BACKEND_URL}/users/${auth.userId}`,
                        'GET',
                        null,
                        {
                            Authorization: 'Bearer ' + auth.token
                        }
                    );
                    /*
                    const userResponse = await sendRequest(
                        `http://localhost:5001/api/users/${auth.userId}`
                    );
                    */

                    setFormData(
                        {
                            ...INITIAL_FORM_STATE,

                            name: {
                                value: userResponse.user.name || '',
                                isValid: true
                            },

                            email: {
                                value: userResponse.user.email || '',
                                isValid: true
                            },

                            mobile: {
                                value: userResponse.user.mobile || '',
                                isValid: true
                            }
                        },
                        false
                    );
                } catch (userErr) {
                    //console.error('Failed to load user:', userErr);
                    //console.error(userErr);
                    throw userErr;
                }

            }
        };

        fetchUser();
    }, [auth.userId, auth.token, sendRequest, setFormData, clearError]);


    /*[auth, sendRequest, setFormData, clearError]);*/
    /* [auth.userId, sendRequest, setFormData]); */

    /*
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const responseData =
                    await sendRequest(
                        `http://localhost:5001/api/users/${auth.userId}`
                    );
                //console.log("AUTH USER ID:", auth.userId);
                //console.log("USER RESPONSE:", responseData);

                setFormData(

                    {
                        /*...formState.inputs,*
                        ...INITIAL_FORM_STATE,

                        name: {
                            value:
                                responseData.user.name,
                            isValid: true
                        },

                        email: {
                            value:
                                responseData.user.email,
                            isValid: true
                        },

                        mobile: {
                            value:
                                responseData.user.mobile,
                            isValid: true
                        }
                    },
                    false
                );
            } catch (err) { }
        };

        fetchUser();
    }, [
        auth.userId,
        sendRequest,
        setFormData
    ]);
    */

    const history = useHistory();

    const registerSubmitHandler = async event => {
        event.preventDefault();

        console.log(formState.inputs);

        const registerData = {
            userId: auth.userId,

            name: formState.inputs.name.value,
            gender: formState.inputs.gender.value,
            city: formState.inputs.city.value,
            email: formState.inputs.email.value,
            mobile: formState.inputs.mobile.value,
            highedu: formState.inputs.highedu.value,
            whatsAppNumber: formState.inputs.whatsAppNumber.value,
            preferredLanguage: formState.inputs.preferredLanguage.value,

            interests: [
                formState.inputs.interest1.value,
                formState.inputs.interest2.value,
                formState.inputs.interest3.value,
                formState.inputs.interest4.value
            ],

            services: [
                formState.inputs.services1.value,
                formState.inputs.services2.value,
                formState.inputs.services3.value,
                formState.inputs.services4.value
            ],

            rateCard: {
                consultation: formState.inputs.cunsultationCharges.value,
                solution1: formState.inputs.solutionCharges1.value,
                solution2: formState.inputs.solutionCharges2.value,
                description: formState.inputs.description.value

            }
        };

        //console.log(registerData);

        if (isEditMode) {

            await sendRequest(
                //`http://localhost:5001/api/users/${auth.userId}/register`,
                `${process.env.REACT_APP_BACKEND_URL}/users/${auth.userId}/register`,
                'PATCH',
                JSON.stringify(registerData),
                {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + auth.token
                }
            );

            toast.success('Profile updated successfully');

        } else {

            await sendRequest(
                //`http://localhost:5001/api/users/${auth.userId}/register`,
                `${process.env.REACT_APP_BACKEND_URL}/users/${auth.userId}/register`, 
                'POST',
                JSON.stringify(registerData),
                {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + auth.token
                }
            );

            auth.setIsRegistered(true);

            toast.success('Registration saved successfully');
        }

        history.push(`/${auth.userId}/profile`);

        /*
        try {
            await sendRequest(
                `http://localhost:5001/api/users/${auth.userId}/register`,
                'POST',
                JSON.stringify(registerData),
                {
                    'Content-Type':
                        'application/json'
                }
            );

            auth.setIsRegistered(true);
            /*
            alert(
                'Registration saved successfully'
            );
            *
            history.push(`/${auth.userId}/profile`);
            //history.push('/');
            toast.success("Registration saved successfully");
        } catch (err) { toast.error(err.message || "Registration failed."); }
        */

    };

    return (
        <React.Fragment>
            <ErrorModal error={error} onClear={clearError} />
            <form className="register-form" onSubmit={registerSubmitHandler}>
                {isLoading && <LoadingSpinner asOverlay />}
                <h3>Personal :</h3>
                <div className="personal-grid">
                    <Input
                        id="name"
                        element="input"
                        type="text"
                        label="Name"
                        value={formState.inputs.name.value}
                        //disabled
                        readOnly
                        initialValid={true}
                        validators={[]}
                        //validators={[VALIDATOR_REQUIRE()]}
                        //errorText="Please enter your name."
                        onInput={inputHandler}
                    />

                    <Input
                        id="gender"
                        element="input"
                        type="text"
                        label="Gender"
                        value={formState.inputs.gender.value}
                        initialValid={formState.inputs.gender.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter gender."
                        onInput={inputHandler}
                    />

                    <Input
                        id="city"
                        element="input"
                        type="text"
                        label="City"
                        value={formState.inputs.city.value}
                        initialValid={formState.inputs.city.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter city."
                        onInput={inputHandler}
                    />

                    <Input
                        id="email"
                        element="input"
                        type="email"
                        label="Email"
                        value={formState.inputs.email.value}
                        readOnly
                        initialValid={true}
                        validators={[]}
                        //disabled
                        //validators={[VALIDATOR_EMAIL()]}
                        //errorText="Please enter a valid email."
                        onInput={inputHandler}
                    />

                    <Input
                        id="mobile"
                        element="input"
                        type="text"
                        label="Mobile"
                        value={formState.inputs.mobile.value}
                        readOnly
                        initialValid={true}
                        validators={[]}
                        //disabled
                        //validators={[VALIDATOR_REQUIRE()]}
                        //errorText="Please enter mobile number."
                        onInput={inputHandler}
                    />

                    <Input
                        id="highedu"
                        element="input"
                        type="text"
                        label="Highest Qualification"
                        value={formState.inputs.highedu.value}
                        initialValid={formState.inputs.highedu.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter qualification."
                        onInput={inputHandler}
                    />

                    <Input
                        id="whatsAppNumber"
                        element="input"
                        //type="text"
                        type="number"
                        label="WhatsApp Number"
                        value={formState.inputs.whatsAppNumber.value}
                        initialValid={formState.inputs.whatsAppNumber.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter valid whatsApp Number."
                        onInput={inputHandler}
                    />

                    <Input
                        id="preferredLanguage"
                        element="input"
                        type="text"
                        label="Preferred Language"
                        value={formState.inputs.preferredLanguage.value}
                        initialValid={formState.inputs.preferredLanguage.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter preferred Language."
                        onInput={inputHandler}
                    />
                </div>

                {/*<h3>Area of Interest :</h3>*/}
                <h3>Key Skills :</h3>
                <div className="interest-grid">
                    <Input
                        id="interest1"
                        element="input"
                        type="text"
                        //label="Interest 1"
                        label="Skills 1"
                        value={formState.inputs.interest1.value}
                        initialValid={formState.inputs.interest1.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter interest 1."
                        onInput={inputHandler}
                    />
                    <Input
                        id="interest2"
                        element="input"
                        type="text"
                        label="Skills 2"
                        value={formState.inputs.interest2.value}
                        initialValid={formState.inputs.interest2.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter interest 2."
                        onInput={inputHandler}
                    />
                    <Input
                        id="interest3"
                        element="input"
                        type="text"
                        label="Skills 3"
                        value={formState.inputs.interest3.value}
                        initialValid={formState.inputs.interest3.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter interest 3."
                        onInput={inputHandler}
                    />
                    <Input
                        id="interest4"
                        element="input"
                        type="text"
                        label="Skills 4"
                        value={formState.inputs.interest4.value}
                        initialValid={formState.inputs.interest4.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter interest 4."
                        onInput={inputHandler}
                    />
                </div>

                <h3>Services Offered :</h3>
                <div className="services-grid">
                    <Input
                        id="services1"
                        element="input"
                        type="text"
                        label="Service 1"
                        value={formState.inputs.services1.value}
                        initialValid={formState.inputs.services1.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter service 1."
                        onInput={inputHandler}
                    />
                    <Input
                        id="services2"
                        element="input"
                        type="text"
                        label="Service 2"
                        value={formState.inputs.services2.value}
                        initialValid={formState.inputs.services2.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter service 2."
                        onInput={inputHandler}
                    />
                    <Input
                        id="services3"
                        element="input"
                        type="text"
                        label="Service 3"
                        value={formState.inputs.services3.value}
                        initialValid={formState.inputs.services3.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter service 3."
                        onInput={inputHandler}
                    />
                    <Input
                        id="services4"
                        element="input"
                        type="text"
                        label="Service 4"
                        value={formState.inputs.services4.value}
                        initialValid={formState.inputs.services4.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter service 4."
                        onInput={inputHandler}
                    />
                </div>

                {/*<h3>Rate Card :</h3>*/}
                <h3>Charges :</h3>
                <div className="rate-grid">
                    <Input
                        id="cunsultationCharges"
                        element="input"
                        //type="text"
                        type="number"
                        label="Consultation Charges (Rs.)"
                        value={formState.inputs.cunsultationCharges.value}
                        initialValid={formState.inputs.cunsultationCharges.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter valid consultation charges using numbers only."
                        onInput={inputHandler}
                    />

                    <Input
                        id="solutionCharges1"
                        element="input"
                        type="number"
                        label="Solution Charges (Rs.) "
                        value={formState.inputs.solutionCharges1.value}
                        initialValid={formState.inputs.solutionCharges1.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter valid solution charges using numbers only."
                        onInput={inputHandler}
                    />

                    <Input
                        id="solutionCharges2"
                        element="input"
                        type="number"
                        label="Monthly Charges (Rs.) "
                        value={formState.inputs.solutionCharges2.value}
                        initialValid={formState.inputs.solutionCharges2.isValid}
                        validators={[VALIDATOR_REQUIRE()]}
                        errorText="Please enter valid monthly charges using numbers only."
                        onInput={inputHandler}
                    />

                    <div className="full-width">
                        <Input
                            id="description"
                            element="textarea"
                            type="text"
                            label="Description"
                            value={formState.inputs.description.value}
                            initialValid={formState.inputs.description.isValid}
                            validators={[VALIDATOR_REQUIRE()]}
                            errorText="Please enter description."
                            rows="4"
                            onInput={inputHandler}
                        />
                    </div>
                </div>

                <div className="form-actions">
                    <Button type="submit" disabled={!formState.isValid}>
                        {/*Submit*/}
                        {isEditMode ? "Update" : "Submit"}
                    </Button>

                    <Button type="button" onClick={() => history.push(`/${auth.userId}/profile`)}>
                        Cancel
                    </Button>
                </div>
            </form>
            {/* Footer */}
            {/*
            <Footer />
            */}
        </React.Fragment>

    );
};

export default UserRegister;